module.exports = __webpack_public_path__ + "img/map-large-5.d95a141f.jpg";